module.exports = __webpack_public_path__ + "static/media/chejianchanyegongren.45826665.png";